import { Modal } from "@circle-react-uikit/ModalV2";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { useFormRenderingContext } from "../contexts/FormRenderingContext";

interface ModalHeaderProps {
  handleClose: () => void;
}
export const ModalHeader = ({ handleClose }: ModalHeaderProps) => {
  // this should always return either null or a TextElementType, HELP
  const { titleElement, shouldRenderEndingPage } = useFormRenderingContext();
  const showTitle = !shouldRenderEndingPage && titleElement;
  return (
    <Modal.Header
      className={classNames("border-none", { "!justify-end": !showTitle })}
    >
      {showTitle ? (
        <>
          <Modal.Title>{titleElement.attributes.value}</Modal.Title>
          <Modal.HeaderActions>
            <Modal.CloseButton
              id="form-modal-close-button"
              onClick={handleClose}
            />
          </Modal.HeaderActions>
        </>
      ) : (
        <Modal.CloseButton id="form-modal-close-button" onClick={handleClose} />
      )}
    </Modal.Header>
  );
};
